angular.module('internal.investigations')
    .directive('internalInvestigationHeader', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'investigations/components/investigation-header/investigation-header.html',
            controller: 'InternalInvestigationHeader',
            replace: true
        };
    }])
    .controller('InternalInvestigationHeader', ['$scope', 'Permissions', function ($scope, Permissions) {
        $scope.getPermission = function (state, variable, method) {
            Permissions[method](state).then(function (access) {
                $scope[variable] = access;
            })
        }
    }])
;